<template>
  <div id="sispessoal-wrapper">
    <TheHeader class="theheader-container" />
    <main id="sispessoal-content" class="grey lighten-4">
      <router-view />
      <!--<TheVLibras /> -->
      <!--<BaseHelpInfotic v-show="!isInModulo" v-bind="helpInfotic" /> -->
    </main>
    <TheFooter />
  </div>
</template>

<script>
import { MODULOS_ROUTE } from "./constants";

import TheHeader from "./components/TheHeader.vue";
import TheFooter from "./components/TheFooter.vue";
// import TheVLibras from "./components/TheVLibras.vue";

export default {
  name: "app",
  components: {
    TheFooter,
    TheHeader,
    // TheVLibras
  },
  inheritAttrs: false,
  /*data() {
    return {
      helpInfotic: {
        appName: APP_INFO.name,
        contacts: [{ name: "PR-4", email: "atendimento@pr4.ufrj.br" }],
        helpUrl: `${HELP_INFOTIC_URL}/duvidas-sistema/${APP_INFO.name}`,
      },
    };
  },*/
  computed: {
    isInModulo() {
      return (
        this.$route &&
        this.$route.path &&
        this.$route.path.indexOf(`${MODULOS_ROUTE}/`) >= 0
      );
    },
  },
  created() {
    const store = this.$store;

    const infoCardIds = [
      "sispessoal-meusdados-infocard",
      "sispessoal-controleacesso-atividade-modal-infocard",
      "sispessoal-controleacesso-perfis-modal-infocard",
      "sispessoal-controleacesso-usuarios-infocard",
      "sispessoal-controleacesso-usuarios-modal-infocard",
      "sispessoal-controleacesso-usuarios-trocarsenha-modal-infocard",
    ];

    infoCardIds.forEach((item) => store.commit("addInfoCardId", item));
    infoCardIds.forEach((item) => store.commit("importInfoCard", item));
  },
};
</script>

<style>
html,
body {
  height: 100vh;
}

main {
  flex-grow: 1;
}

#sispessoal-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-height: max-content;
}

h1 i.material-icons,
h2 i.material-icons,
h3 i.material-icons,
h4 i.material-icons,
h5 i.material-icons {
  line-height: 110%;
  font-size: inherit;
}

.row-fix {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.justify-align {
  text-align: justify;
}

.buttons-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

@media screen and (max-width: 600px) {
  .buttons-row .btn {
    display: block;
    width: 100%;
    margin: 0 0 20px 0;
  }
  .buttons-row .btn:last-of-type {
    margin-bottom: 0;
  }
}

/* O id nesta regra é necessário para aumentar a seletividade e a regra ser aplicada */
.contrast #sispessoal-content {
  background-color: black !important;
}
.theheader-container {
  position: sticky;
  top: 0;
  z-index: 100;
}
</style>
